import { BottomSheetModal } from '@gorhom/bottom-sheet';
import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

const PURCHASE_RESTRICTION_KEYS = [
  'diningTravel',
  'ridesDelivery',
  'gasPumps',
  'gambling',
  'cash',
  'restrictedProducts',
  'cryptocurrency',
  'prepaidGiftCards',
  'taxesBailPawn',
  'jewelryPreciousMetals',
] as const;

interface PurchaseRestrictionsBottomSheetProps {
  ref: RefObject<BottomSheetModal | null>;
}

const PurchaseRestrictionsBottomSheet = ({
  ref,
}: PurchaseRestrictionsBottomSheetProps) => {
  const { t: translatedText } = useTranslation('payLater', {
    keyPrefix: 'purchaseRestrictions',
  });

  const restrictions = PURCHASE_RESTRICTION_KEYS.map((restrictionKey) =>
    translatedText(`restrictions.${restrictionKey}`),
  );

  const handleDonePress = () => {
    ref.current?.dismiss();
  };

  return (
    <BottomSheet ref={ref}>
      <View style={styles.content}>
        <TitleMdText accessibilityRole="header" numberOfLines={0}>
          {translatedText('title')}
        </TitleMdText>
        <BodyBaseText numberOfLines={0}>{translatedText('body')}</BodyBaseText>
        <ContentList contentList={restrictions} />
      </View>
      <View style={styles.buttonContainer}>
        <Button label={translatedText('done')} onPress={handleDonePress} />
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    padding: theme.spacing.m,
  },
  content: {
    gap: theme.spacing.s,
    padding: theme.spacing.m,
  },
});

export default PurchaseRestrictionsBottomSheet;
